module.exports = __webpack_public_path__ + "static/media/lazada_logo.e1173a16.png";